const prefixName = '@pld/PldCatalogs/';

export const SET_PLD_CATALOGS = `${prefixName}set_pld_catalogs`;
export const SET_PLD_CATALOG_LOADING = `${prefixName}set_pld_catalog_loading`;
export const SET_PLD_CATALOG_ERROR = `${prefixName}set_pld_catalog_error`;
export const CLEAR_PLD_CATALOGS = `${prefixName}clear_pld_catalogs`;
